function BrowserslistError (message) {
  this.name = 'BrowserslistError'
  this.message = message
  this.browserslist = true
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, BrowserslistError)
  }
}

BrowserslistError.prototype = Error.prototype

module.exports = BrowserslistError



//////////////////
// WEBPACK FOOTER
// ./~/browserslist/error.js
// module id = 212
// module chunks = 79718873386587